export default "<p class=\"hidden-xs\">Seleziona un video!</p>\n";